<template>
  <div id="manager">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="文本查询">
          <el-input
            placeholder="请输入内容"
            clearable
            v-model="formInline.PhoneNumber"
            class="input-with-select"
          >
            <el-button
              @click="handleCurrentChange(1)"
              slot="append"
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </el-form-item>
        <el-form-item
          label=""
          label-width="0px"
        >
          <el-button
            type="primary"
            @click="dialogVisible = true"
          >新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="managerList"
        border
        style="width: 100%"
      >

        <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="用户名 "
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="phoneNumber"
          label="手机号 "
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="创建时间"
        >
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.createTime?scope.row.createTime.slice(0,10):''}}</span> -->
            <span>{{ scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteM(scope.row)"
              type="danger"
              size="mini"
              plain
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="添加管理员"
      :visible.sync="dialogVisible"
      :before-close="close"
      width="30%"
    >
      <el-form
        :model="addForm"
        ref="addForm"
        :rules="addRules"
      >
        <el-form-item
          label="手机号"
          label-width="80px"
          prop="phoneNumber"
          :rules="[{ validator: phone, trigger: 'blur' }]"
        >
          <el-input
            v-model="addForm.phoneNumber"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancle">取 消</el-button>
        <el-button
          type="primary"
          @click="addManager"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAdministration, addAdministration, deleteAdmin } from 'api/request'
import { SetTableH } from '../../utils/utils'
export default {
  data() {
    return {
      tableH: '250',
      loading: true,
      addForm: {
        phoneNumber: ''
      },
      formInline: {
        PhoneNumber: ''
      },
      addRules: {},
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10
      },
      managerList: [],
      dialogVisible: false
    }
  },
  components: {},
  methods: {
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      this.getManagerList()
    },
    handleCurrentChange(val) {
      this.pageObj.PageIndex = val
      this.getManagerList()
    },
    async getManagerList() {
      let params = {
        PageIndex: this.pageObj.PageIndex,
        PageSize: this.pageObj.PageSize,
        PhoneNumber: this.formInline.PhoneNumber
      }
      this.loading = true
      let data = await getAdministration(params)
      if (data) {
        this.managerList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    },
    async addManager() {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          let params = {
            phoneNumber: this.addForm.phoneNumber
          }
          addAdministration(params).then(data => {
            if (data) {
              this.dialogVisible = false
              this.addForm.phoneNumber = ''
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.getManagerList()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async deleteM(item) {
      this.$confirm(
        `是否确定删除手机号为${item.phoneNumber}的管理员?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          deleteAdmin(item.id).then(data => {
            if (data) {
              this.$message({
                message: '已成功删除',
                type: 'warning'
              })
              this.getManagerList()
            }
          })
        })
        .catch(() => {})
    },
    cancle() {
      this.$refs['addForm'].resetFields()
      this.dialogVisible = false
    },
    close() {
      this.$refs['addForm'].resetFields()
      this.dialogVisible = false
    },
    /**
     * 手机校验
     */
    phone(rule, value, callback) {
      let rep = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
      const rs = rep.test(value)
      if (!rs && value) {
        callback(new Error('请输入正确手机号码'))
      } else {
        callback()
      }
    }
  },
  mounted() {
    SetTableH(this)
  },
  created() {
    this.getManagerList()
  }
}
</script>
<style lang='scss'>
#manager {
  height: 100%;
  width: 100%;
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
